import api from '../api';
import { tokenService } from '../auth/tokenService';

export const groupService = {
  groupsList: async (params) => {
    try {
      const response = await api.get(`groups/groups/cms`, {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  downloadGroups: async (params) => {
    try {
      const response = await api.get('groups/groups/cms', {
        responseType: 'blob',
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`,
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      });

      // Crear el blob y el enlace de descarga
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'users.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  groupsListUser: async (user_id, params) => {
    try {
      const response = await api.get(`chats/cms/group/user/${user_id}/filtered-paginated`, {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getOrganizations: async () => {
    try {
      const response = await api.get('chats/chat/group/organization-types', {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getOwners: async (params) => {
    try {
      const response = await api.get('users/filtered/paginated', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createGroup: async (groupData) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/chats/group/create`;
      const requestConfig = {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        },
        body: groupData
      };

      console.log('Enviando grupo al servidor...', {
        url,
        headers: requestConfig.headers,
        body: groupData
      });

      const res = await fetch(url, requestConfig);
      
      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      console.log('Respuesta del servidor:', data);
      return data;
    } catch (error) {
      console.error("Error creating group:", error);
      throw error; // Propagar el error para manejarlo en el componente
    }
  },

  updateGroup: async (groupId, groupData) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/groups/cms/group/${groupId}`;
      const requestConfig = {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        },
        body: groupData
      };

      console.log('Enviando grupo al servidor...', {
        url,
        headers: requestConfig.headers,
        body: groupData
      });

      const res = await fetch(url, requestConfig);
      
      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      console.log('Respuesta del servidor:', data);
      return data;
    } catch (error) {
      console.error("Error creating group:", error);
      throw error; // Propagar el error para manejarlo en el componente
    }
  },

  dataGroup: async (id) => {
    try {
      const response = await api.get(`chats/group/${id}/info`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getMembersByGroup: async (id, params) => {
    try {
      const response = await api.get(`groups/group/${id}/members`, {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getMessagesByGroup: async (id) => {
    try {
      const response = await api.get(`chats/chat/${id}/with-sender-names`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      console.log('Messages response:', response.data?.data);
      return {
        messages: response.data?.data?.messages || [],
        participants: response.data?.data?.participants || []
      };
    } catch (error) {
      throw error;
    }
  },

  getTicketsByGroup: async (id) => {
    try {
      const response = await api.get(`chats/group/${id}/tickets`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteUserFromGroup: async (groupId, userId) => {
    try {
      const response = await api.delete(`chats/group/${groupId}/user/${userId}`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getPermissionsmemeberGroup: async (groupId, userId) => {
    try {
      const response = await api.get(`groups/group/cms/${groupId}/member/${userId}/permissions`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updatePermissionsmemeberGroup: async (groupId, userId, permissions) => {
    try {
      const response = await api.put(`groups/group/cms/${groupId}/member/${userId}/permissions`, permissions, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  serviceOfferedGroup: async (groupId, params) => {
    try {
      const response = await api.get(`groups/group/${groupId}/offered-services`, {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  changeStatusGroup: async (groupId, activate) => {
    try {
      const formData = new URLSearchParams();
      formData.append('activate', activate);
      
      const response = await api.put(`chats/group/${groupId}/status`, formData, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  groupdetail: async (groupId) => {
    try {
      const response = await api.get(`groups/groups/${groupId}`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  changeStatusMember: async (groupId, userId, status) => {
    try {
      const response = await api.patch(`groups/group/cms/${groupId}/members/${userId}/status`, status, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteGroup: async (groupId) => {
    try {
      const response = await api.delete(`groups/cms/group/${groupId}/delete`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};